import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4atn7bfq6: FaireProductEntity = {
  token: "p_b4atn7bfq6",
  type: "product",
  name: "Coastal Life is better at the Beach 12 oz Canvas Tote Bag",
  brandName: "Avery Lane Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/4d635a06b3284f9b3c09e32cd648e4eb86ba588210c05d68de2e3038563d3888.jpeg",
  priceDollars: 8.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/aad6b13b5c4d15de8fbe3cb02273e160d6605613a4645bd7a8c4b1e516aa460a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
